import { post } from './api';

/**
 * Records a deposit transaction in the database
 * @param {string} userId - The user's unique identifier (email or wallet address)
 * @param {string} walletAddress - The user's wallet address
 * @param {string} poolType - Type of pool ('regular' or 'protected')
 * @param {number} amount - Amount deposited in USDC (including decimals)
 * @param {string} transactionHash - The transaction hash
 * @returns {Promise<Object>} - The created transaction record
 */
export const recordDeposit = async (userId, walletAddress, poolType, amount, transactionHash) => {
  try {
    return await post('/savings/deposit', {
      userId,
      walletAddress,
      poolType,
      amount,
      transactionHash,
    });
  } catch (error) {
    console.error('Error recording deposit:', error);
    throw error;
  }
};

/**
 * Records a withdrawal transaction in the database
 * @param {string} userId - The user's unique identifier (email or wallet address)
 * @param {string} walletAddress - The user's wallet address
 * @param {string} poolType - Type of pool ('regular' or 'protected')
 * @param {number} amount - Amount withdrawn in USDC (including decimals)
 * @param {string} transactionHash - The transaction hash
 * @returns {Promise<Object>} - The created transaction record
 */
export const recordWithdrawal = async (userId, walletAddress, poolType, amount, transactionHash) => {
  try {
    return await post('/savings/withdraw', {
      userId,
      walletAddress,
      poolType,
      amount,
      transactionHash,
    });
  } catch (error) {
    console.error('Error recording withdrawal:', error);
    throw error;
  }
};
